"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unlock = exports.trollhit = exports.ratdeath = exports.pickupsword = exports.pickupkey = exports.pickupheart = exports.pickup1 = exports.jellyhit = exports.hitweb = exports.hitspike = exports.hitspider = exports.hitslime = exports.hitlava = exports.hitgoblin = exports.hitcrate = exports.hitbytroll = exports.hitbygoblin2 = exports.hitbygoblin = exports.ghost1 = exports.eat1 = exports.createbreak2 = exports.cratebreak = exports.blobhit = exports.bit = exports.batdeath = exports.wood2 = exports.wood1 = void 0;
// autogen index file for audioSprite2
exports.wood1 = 'wood1';
exports.wood2 = 'wood2';
exports.batdeath = 'batdeath';
exports.bit = 'bit';
exports.blobhit = 'blobhit';
exports.cratebreak = 'cratebreak';
exports.createbreak2 = 'createbreak2';
exports.eat1 = 'eat1';
exports.ghost1 = 'ghost1';
exports.hitbygoblin = 'hitbygoblin';
exports.hitbygoblin2 = 'hitbygoblin2';
exports.hitbytroll = 'hitbytroll';
exports.hitcrate = 'hitcrate';
exports.hitgoblin = 'hitgoblin';
exports.hitlava = 'hitlava';
exports.hitslime = 'hitslime';
exports.hitspider = 'hitspider';
exports.hitspike = 'hitspike';
exports.hitweb = 'hitweb';
exports.jellyhit = 'jellyhit';
exports.pickup1 = 'pickup1';
exports.pickupheart = 'pickupheart';
exports.pickupkey = 'pickupkey';
exports.pickupsword = 'pickupsword';
exports.ratdeath = 'ratdeath';
exports.trollhit = 'trollhit';
exports.unlock = 'unlock';
